// routing
import Routes from 'routes';

// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';
import ConfirmDialog from 'ui-component/extended/ConfirmDialog';
import ThemeCustomization from 'themes';

// auth provider
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import LoadingSpinner from 'ui-component/LoadingSpinner';
import LoadingCursor from 'ui-component/LoadingCursor';
import TalkBot from 'ui-component/TalkBot';
// ==============================|| APP ||============================== //

const App = () => (
    <ThemeCustomization>
        {/* RTL layout */}
        <RTLLayout>
            <Locales>
                <NavigationScroll>
                    <AuthProvider>
                        <>
                            <Routes />
                            <Snackbar />
                            <ConfirmDialog />
                        </>
                    </AuthProvider>
                </NavigationScroll>
                <LoadingSpinner />
                <LoadingCursor />
                <TalkBot />
            </Locales>
        </RTLLayout>
    </ThemeCustomization>
);

export default App;
